module.exports = __webpack_public_path__ + "img/ir.f6903c10.svg";